// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyWizard__WarningHeader = require("./PropertyWizard__WarningHeader.bs.js");

function PropertyWizardRelay__BroadcastQuietSellerWarning(props) {
  switch (props.privacy) {
    case "ANONYMOUS" :
      return JsxRuntime.jsx(PropertyWizard__WarningHeader.make, {
        icon: JsxRuntime.jsx(IconV5.make, {
          icon: "attention-alt",
          size: 30,
          className: "text-black"
        }),
        headingText: "Broadcasting this property will reveal your name",
        variant: "Warning",
        children: JsxRuntime.jsx("div", {
          children: "You originally used Hide My Name on this seller to  remain anonymous. Promoting to a broadcast will reveal your identity on all previous matches and conversations."
        })
      });
    case "HIDDEN" :
    case "NORMAL" :
      return null;
  }
}

let make = PropertyWizardRelay__BroadcastQuietSellerWarning;

exports.make = make;
/* IconV5 Not a pure module */
